export const basePath = "/BIPartnerCenter";
